import client from '@/api/client'

/**
 * Sign in
 *
 * @param {String} emailPhone
 * @param {String} password
 * @returns {Promise}
 */
export function signIn(emailPhone, password) {
  return client
    .post(
      '/tokens/new',
      {
        email_phone: emailPhone,
        password: password
      },
      {
        baseURL: '/'
      }
    )
    .then(response => response.data)
}
/**
 * Refresh token
 *
 * @param {String} accessToken
 * @param {String} refreshToken
 * @returns {Promise}
 */
export function refresh(accessToken, refreshToken) {
  return client
    .post(
      '/tokens/refresh',
      {
        refresh_token: refreshToken,
        access_token: accessToken
      },
      {
        baseURL: '/'
      }
    )
    .then(response => response.data)
}



// WEBPACK FOOTER //
// ./src/apps/auth/api/index.js